"use client";

import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const servicesData = [{
  id: "01",
  title: "Cloud Computing Essential Training",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_essentials_course.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_essentials_course.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_essentials_course.png-wvc-sizes",
    alt: "Cloud Computing Essential Training course cover"
  },
  description: "Master the fundamental concepts of cloud computing. This course covers the core models, deployment strategies, and the business value of migrating to the cloud.",
  feature: "LinkedIn Learning: cloud-computing-essential-training"
}, {
  id: "02",
  title: "AI Fundamentals",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/ai_fundamentals_course.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/ai_fundamentals_course.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/ai_fundamentals_course.png-wvc-sizes",
    alt: "AI Fundamentals course cover"
  },
  description: "Explore the world of Artificial Intelligence. Learn about machine learning, neural networks, and how AI is transforming modern business operations.",
  feature: "LinkedIn Learning: ai-fundamentals"
}, {
  id: "03",
  title: "Leveraging Agentic AI",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/agentic_ai_course.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/agentic_ai_course.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/agentic_ai_course.png-wvc-sizes",
    alt: "Leveraging Agentic AI course cover"
  },
  description: "Discover the power of autonomous AI agents. Learn how to design and deploy agentic systems that can reason, plan, and execute complex tasks.",
  feature: "LinkedIn Learning: leveraging-agentic-ai"
}, {
  id: "04",
  title: "Cloud Architecture Core Concepts",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_course.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_course.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/cloud_architecture_course.png-wvc-sizes",
    alt: "Cloud Architecture Core Concepts course cover"
  },
  description: "Deep dive into the architectural principles of the cloud. Understand scalability, high availability, and fault tolerance in modern distributed systems.",
  feature: "LinkedIn Learning: cloud-architecture-core-concepts"
}, {
  id: "05",
  title: "Generative AI in Cloud",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/gen_ai_cloud_course.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/gen_ai_cloud_course.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/gen_ai_cloud_course.png-wvc-sizes",
    alt: "Generative AI in Cloud course cover"
  },
  description: "Learn how to integrate Generative AI models within cloud environments. Explore LLMs, prompt engineering, and cloud-native AI services.",
  feature: "LinkedIn Learning: generative-ai-in-cloud"
}];
export default function CourseListing() {
  const [activeTab, setActiveTab] = useState(0);
  return <section data-section-id="253427" id="course-listing" className="py-16 md:py-24 bg-background text-foreground relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[140%] bg-muted/30 transform rotate-12 opacity-50"></div>
      </div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground max-w-4xl mx-auto leading-tight">
            Explore Our Professional Cloud & AI Curriculum
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
          <div className="lg:col-span-4 flex flex-col gap-3">
            {servicesData.map((service, i) => <div key={service.id} data-index={i}>
                <Button onClick={() => setActiveTab(i)} className={`w-full flex items-center justify-between p-4 md:p-5 text-left font-semibold transition-all duration-300 rounded-md ${activeTab === i ? "bg-primary text-primary-foreground shadow-lg" : "bg-card text-card-foreground hover:bg-accent hover:text-accent-foreground shadow-sm"}`} variant={activeTab === i ? "default" : "outline"} aria-selected={activeTab === i} role="tab">
                  <span className="text-base md:text-lg font-default">{service.title}</span>
                  <ArrowUpRight className={`w-5 h-5 shrink-0 transition-transform duration-300 ${activeTab === i ? "text-primary-foreground translate-x-1 -translate-y-1" : "text-muted-foreground"}`} />
                </Button>
              </div>)}
          </div>

          <div className="lg:col-span-4 h-[400px] lg:h-auto min-h-[450px]">
            <div className="bg-sidebar p-6 flex flex-col h-full w-full relative overflow-hidden rounded-md shadow-md">
              <div className="relative flex-grow mb-6 w-full h-full min-h-[250px]">
                <img src={servicesData[activeTab].image.src} data-wvc-srcset={servicesData[activeTab].image.srcset} data-wvc-sizes={servicesData[activeTab].image.sizes} alt={servicesData[activeTab].image.alt} className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 rounded-md" loading="lazy" />
              </div>
              <div className="flex items-center justify-between text-sidebar-foreground/70 mt-auto pt-4 border-t border-sidebar-border shrink-0">
                <span className="tracking-widest text-sm uppercase font-medium font-default">
                  Course Module
                </span>
                <span className="text-5xl md:text-6xl font-default font-bold text-sidebar-foreground/10 leading-none">
                  {servicesData[activeTab].id}
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col justify-center py-4 lg:pl-4">
            <h3 className="text-3xl md:text-4xl font-default font-bold mb-6 text-foreground">
              Course Overview
            </h3>
            <h4 className="text-xl font-semibold mb-4 text-foreground font-default">
              {servicesData[activeTab].title}
            </h4>
            <p className="text-muted-foreground mb-8 leading-relaxed text-base md:text-lg font-default">
              {servicesData[activeTab].description}
            </p>

            <div className="flex items-start gap-4 mb-10">
              <div className="mt-1 text-secondary shrink-0">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 12L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <span className="font-medium text-foreground text-base md:text-lg font-default">
                {servicesData[activeTab].feature}
              </span>
            </div>

            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 py-6 h-auto font-semibold tracking-wide text-sm md:text-base w-fit shadow-md transition-all">
              <Link to="https://www.linkedin.com/learning/">
                VIEW ON LINKEDIN <ArrowUpRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}